import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { API_URL } from '../../../config/constants';
import { NodeEvent } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface EventProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeEvent>;
}

const NodeEventPage: React.FC<EventProps> = ({ entity, className }) => {
  const classes = classNames(className, 'NodeEvent');
  const event = entity.toJS();

  const title = event.title[0].value;
  const date = new Date(event.field_date[0].value);
  const body = event.body[0]?.processed;
  const link = event.field_link[0]?.alias || event.field_link[0]?.uri;
  const linkTitle = event.field_link[0]?.title;

  const imageStyles = event.field_media_item[0]?.styles;
  const src = [
    `${API_URL}${imageStyles?.ratio_1_1_xs || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_sm || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_md || ''}`,
    `${API_URL}${imageStyles?.ratio_1_1_xl || ''}`,
  ];

  const audiences = event.field_target_audiences;
  const labels = event.field_labels;
  const location = event.field_location[0]?.entity.name[0].value;
  const status = event.field_status[0]?.entity.name[0]?.value;
  const type = event.field_type[0].entity.name[0].value;

  return (
    <div className={classes}>
      <div className="NodeEvent__title">
        {title}
      </div>
      <div className="Nodevent__date">
        {date.toLocaleString('nl-NL')}
      </div>
      <div className="NodeEvent__body">
        <WysiwygField html={body} />
      </div>
      {imageStyles && (
        <Image
          src={src}
          alt={title}
        />
      )}
      {link && (
        <div className="NodeEvent__link">
          <CoreLink to={link}>
            {linkTitle}
          </CoreLink>
        </div>
      )}
      <div className="NodeEvent__labels">
        {labels.map((label) => (
          <div className="NodeEvent__labels__label">
            {label.entity.name?.[0]?.value}
          </div>
        ))}
      </div>
      {status && (
        <div className="NodeEvent__status">
          {status}
        </div>
      )}
      <div className="NodeEvent__audiences">
        {audiences.map((audience) => (
          <div className="NodeEvent__audiences__audience">
            {audience.entity.name[0].value}
          </div>
        ))}
      </div>
      {location && (
        <div className="NodeEvent__location">
          {location}
        </div>
      )}
      {type && (
        <div className="NodeEvent__type">
          {type}
        </div>
      )}
    </div>
  );
};

export default NodeEventPage;
